<script>
import {defineComponent} from 'vue'
import {ElMessage, ElNotification} from "element-plus";
import {API_BASE_CATEGORIES, LANG_TABS, TITLE_LANG_LABELS} from "../constants";

export default defineComponent({
  name: "OpennessOrganizationCategoryForm",
  data() {
    return {
      loading: false,
      activeLang: "uz_lat",
      langErrors: [],
      langTabs: LANG_TABS,
      titleLangLabels: TITLE_LANG_LABELS,
      form: {
        id: null,
        order: 0,
        title: {
          uz_cyr: null,
          uz_lat: null,
          kr: null,
          en: null,
          ru: null
        }
      },
      rules: {
        order: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        title: {
          uz_lat: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          uz_cyr: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          ru: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          en: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          kr: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        }
      }
    }
  },
  methods: {
    clearLangError(code) {
      this.langErrors = this.langErrors.filter((c) => c !== code);
    },
    getCategoryById() {
      this.loading = true;
      this.$http.get(`${API_BASE_CATEGORIES}/${this.form.id}`)
          .then(({data}) => {
            this.form.id = data.id;
            this.form.order = data.order;
            this.form.title = data.title;
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response?.data?.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSubmit() {
      this.langErrors = [];
      this.$refs.form.validate((valid, invalidFields) => {
        if (valid) {
          this.loading = true;

          const payload = {
            title: this.form.title,
            order: this.form.order,
          };

          let http;
          if (this.form.id) {
            http = this.$http.put(`${API_BASE_CATEGORIES}/${this.form.id}`, payload);
          } else {
            http = this.$http.post(API_BASE_CATEGORIES, payload);
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response?.data?.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        } else {
          ElMessage.error("Iltimos, majburiy maydonlarni to'ldiring");
          if (invalidFields) {
            this.langErrors = Object.keys(invalidFields)
                .filter((key) => key.startsWith("title."))
                .map((key) => key.split(".")[1]);
            const firstInvalidLang = this.langErrors[0];
            if (firstInvalidLang) this.activeLang = firstInvalidLang;
          }
        }
      })
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.form.id = this.$route.params.id;
      this.getCategoryById()
    }
  }
})
</script>

<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Tartib raqami" prop="order">
                <el-input-number v-model="form.order" :min="0" style="width: 100%"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <fieldset class="form-fieldset">
                <legend>Nomi (barcha tillarda)</legend>
                <el-tabs v-model="activeLang" class="lang-tabs">
                  <el-tab-pane v-for="lt in langTabs" :key="lt.code" :name="lt.code">
                    <template #label>
                      <span class="lang-tab-label" :class="{'lang-tab-label--error': langErrors.includes(lt.code)}">
                        {{ lt.tabLabel }}
                        <span v-if="!form.title[lt.code]" class="lang-tab-dot" title="Bo'sh"/>
                      </span>
                    </template>
                    <el-form-item :label="titleLangLabels[lt.code]" :prop="'title.' + lt.code">
                      <el-input
                          v-model="form.title[lt.code]"
                          :placeholder="titleLangLabels[lt.code]"
                          clearable
                          @input="clearLangError(lt.code)"
                      />
                    </el-form-item>
                  </el-tab-pane>
                </el-tabs>
              </fieldset>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="() => this.$router.go(-1)"
                >Orqaga
                </el-button
                >
                <el-button class="custom-btn" type="primary" @click="onSubmit"
                >Saqlash
                </el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped>
.form-fieldset {
  border: 1px solid var(--el-border-color);
  border-radius: 4px;
  padding: 0 12px 12px;
  margin-bottom: 18px;
}

.form-fieldset legend {
  padding: 0 6px;
  font-size: 13px;
  color: var(--el-text-color-secondary);
}

.lang-tabs {
  margin-bottom: 4px;
}

.lang-tab-label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.lang-tab-label--error {
  color: #f56c6c;
}

.lang-tab-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #e6a23c;
  flex-shrink: 0;
}
</style>
